import API from '../services/api';

export const resetPassword = async (email: string) => {
  const res = await API.post('/user/reset-password', {
    email,
  });
  return res.data;
};

export const getUser = async (userId: string | undefined) => {
  const res = await API.post(`/user/profile`, {
    userId,
  });
  return res.data;
};

export const editUserTerms = async ({ id }: any) => {
  const res = await API.put(`/user/${id}/terms`);
  return res.data;
};

export const editUser = async ({ id, form }: any) => {
  const res = await API.put(`/user/${id}`, {
    ...form,
  });
  return res.data;
};

export const createEnquireMessage = async (
  user_id: string,
  email: string,
  name: string,
  asset_id: string,
  message: string,
  option: string,
  assetId: string
) => {
  const res = await API.post(`/contact`, {
    user_id,

    email,
    name,
    asset_id,
    message,
    option,
    assetId,
  });
  return res.data;
};

export const createContactMessage = async (
  user_id: string | undefined,
  name: string | undefined,
  message: string
) => {
  const res = await API.post(`/contact/message`, {
    user_id,
    name,
    message,
  });
  return res.data;
};
